import * as yup from "yup";

export const schema = yup.object().shape({});

export const initialValues = {
  notSearchable: false,
  availableIn: [],
  jobSizeMin: 0,
  jobSizeMax: 0,
  employees: "",
  entrepreneurWithin: [],
  entrepreneurOffers: [],
  realEstateCompanyType: [],
  realEstateServices: [],
  realEstatePropertyType: [],
  consultingServices: [],
  salesRentalType: [],
  organizationsType: [],
};

// Schema for SearchPreferencesRegions.js
export const regionsSchema = yup.object().shape({
  availableIn: yup
    .array()
    .of(yup.string().required("Each region must be a valid string"))
    .min(1, "Please select at least one region")
    .required("Regions are required"),
});

// Schema for SearchServiceCategories.js
export const serviceCategoriesSchema = yup
  .object()
  .shape({
    entrepreneurWithin: yup.array().of(yup.string()).nullable(),
    entrepreneurOffers: yup.array().of(yup.string()).nullable(),
    materialSupplierType: yup.array().of(yup.string()).nullable(),
    consultingServices: yup.array().of(yup.string()).nullable(),
    salesRentalType: yup.array().of(yup.string()).nullable(),
    organizationsType: yup.array().of(yup.string()).nullable(),
    realEstateCompanyType: yup.array().of(yup.string()).nullable(),
    realEstateServices: yup.array().of(yup.string()).nullable(),
  })
  .test(
    "has-categories",
    "Please select at least one service category",
    function (value) {
      // Get all array fields from the object
      const categoryArrays = Object.values(value || {}).filter(Array.isArray);
      // Check if any array has items
      return categoryArrays.some((arr) => arr && arr.length > 0);
    }
  );

// Initial values for both forms
export const regionsInitialValues = {
  availableIn: [],
};

export const serviceCategoriesInitialValues = {
  entrepreneurWithin: [],
  entrepreneurOffers: [],
  materialSupplierType: [],
  consultingServices: [],
  salesRentalType: [],
  organizationsType: [],
  realEstateCompanyType: [],
  realEstateServices: [],
};
